<!-- Header do diálogo -->
<div matDialogTitle class="dialog-header-row">
  <mat-icon class="dialog-title-icon">storage</mat-icon>
  <span class="dialog-title-text" [title]="data.title">{{ data.title }}</span>
  <button mat-icon-button class="dialog-close-btn" (click)="close()" aria-label="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content-padded">
  <form [formGroup]="produtoForm">

    <!-- Resumo de movimentações -->
    <ng-container *ngIf="detailsMovto && detailsMovto?.numero_lcto > 0; else noMovto">
      <div class="stat-bar">
        <div class="stat-item">
          <mat-icon class="stat-icon primary-color">receipt_long</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Lctos</span>
            <span class="stat-value">{{ detailsMovto.numero_lcto }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon accent-color">event</mat-icon>
          <div class="stat-content">
            <span class="stat-label">1º Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_primeiro_lcto | date: "dd/MM/yy" }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon success-color">event_available</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Último Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_ultimo_lcto | date: "dd/MM/yy" }}</span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noMovto>
      <div class="no-movto-banner">
        <mat-icon>info_outline</mat-icon>
        <span>Nenhum lançamento registrado para este produto</span>
      </div>
    </ng-template>

    <!-- Filtros -->
    <div class="filter-row">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Inicial</mat-label>
        <input matInput type="date" [(ngModel)]="dataInicial"
          (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Final</mat-label>
        <input matInput type="date" [(ngModel)]="dataFinal"
          (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <button mat-raised-button color="primary" class="filter-btn" (click)="reloadPageMovto()">
        <mat-icon>refresh</mat-icon>
        <span class="hide-on-mobile">Atualizar</span>
      </button>
    </div>

    <!-- Mobile: lista de cards -->
    <ng-container *ngIf="layoutConf?.isMobile; else desktopTable">
      <ng-container *ngIf="movtos && movtos.length > 0; else emptyState">
        <div class="movto-card-list">
          <mat-card class="user-card p-0" *ngFor="let movto of movtos">
            <mat-card-title>
              <div class="mobile-card-title">
                <div class="mobile-card-title-actions">
                  <span class="movto-natureza-badge"
                        [class.badge-entrada]="movto?.natureza !== 'S'"
                        [class.badge-saida]="movto?.natureza === 'S'">
                    <mat-icon>{{ movto?.natureza === 'S' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                    {{ movto?.natureza === 'S' ? 'Saída' : 'Entrada' }}
                  </span>
                  <span class="mobile-card-date">{{ movto?.dataMovto | date: 'dd/MM/yy' }}</span>
                  <button mat-icon-button
                          (click)="$event.preventDefault(); openLcto(movto?.lcto?.controle)"
                          matTooltip="Abrir lançamento">
                    <mat-icon color="primary">open_in_new</mat-icon>
                  </button>
                </div>
                <div class="mobile-card-title-description">
                  {{ (movto?.lcto?.serie?.codigo ? movto.lcto.serie.codigo + '-' : '') +
                     (movto?.lcto?.numeroDocto?.toString().padStart(9, '0') || '') }}
                </div>
              </div>
              <mat-divider></mat-divider>
            </mat-card-title>
            <mat-card-content>
              <div class="user-details">
                <table class="mat-table" style="text-align: left; width: 100%;">
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Controle:</td>
                    <td class="mat-cell">{{ movto?.lcto?.controle?.toString().padStart(10, '0') }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Cadastro:</td>
                    <td class="mat-cell overflow-cell">{{ movto?.cadastro?.codigo + ' - ' + movto?.cadastro?.razaoSocial }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Transação:</td>
                    <td class="mat-cell overflow-cell">{{ movto?.fatTransacao?.codigo + ' - ' + movto?.fatTransacao?.descricao }}</td>
                  </tr>
                  <tr class="mat-row" *ngIf="movto?.qtd">
                    <td class="mat-cell label-cell">Qtd:</td>
                    <td class="mat-cell">{{ movto?.qtd | number:'1.2-4' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Total Lcto:</td>
                    <td class="mat-cell"><strong>{{ movto?.lcto?.valortotalDocto | currency: 'BRL' }}</strong></td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
      <ng-template #emptyState>
        <div class="empty-state">
          <mat-icon>inbox</mat-icon>
          <p>Nenhuma movimentação encontrada para o período</p>
        </div>
      </ng-template>
      <mat-paginator
        #paginator
        [length]="length"
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = setPageSizeOptions($event)">
      </mat-paginator>
    </ng-container>

    <!-- Desktop: tabela -->
    <ng-template #desktopTable>
      <ngx-datatable
        class="material"
        [rows]="movtos"
        [headerHeight]="48"
        [footerHeight]="56"
        [scrollbarH]="true"
        [messages]="{ emptyMessage: 'Nenhuma movimentação encontrada p/ o período' }"
        [limit]="pageSize"
        [rowHeight]="48">
        <ngx-datatable-column name="#" [width]="45">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [width]="70">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button color="primary"
                    (click)="$event.preventDefault(); openLcto(row?.lcto?.controle)">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Data" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.dataMovto | date: "dd/MM/yy" }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Controle" [width]="115">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.lcto?.controle?.toString().padStart(10, "0") }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Nat" [width]="85">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [class.saida-text]="row?.natureza === 'S'"
                  [class.entrada-text]="row?.natureza !== 'S'">
              {{ row?.natureza === "S" ? "Saída" : "Entrada" }}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Docto" [width]="130">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ (row?.lcto?.serie?.codigo ? row.lcto.serie.codigo + '-' : '') +
               row?.lcto?.numeroDocto?.toString().padStart(9, "0") }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Cadastro" [flexGrow]="2" [minWidth]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.cadastro?.codigo + "-" + row?.cadastro?.razaoSocial }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Transação" [flexGrow]="2" [minWidth]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.fatTransacao?.codigo + "-" + row?.fatTransacao?.descricao }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Total" [width]="140">
          <ng-template ngx-datatable-header-template>
            <div class="text-right">Total</div>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.lcto?.valortotalDocto | currency: "BRL" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginator
              [length]="length"
              [showFirstLastButtons]="true"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              (page)="pageEvent = setPageSizeOptions($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

  </form>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    <span class="hide-on-mobile">{{ "CLOSE" | translate }}</span>
  </button>
</mat-dialog-actions>